import React from 'react';
import { Select } from 'antd';
import usePerfilActivo from 'hooks/usePerfilActivo';

const ETIQUETAS = {
  ejecutivo: 'Ejecutivo',
  supervisor: 'Supervisor',
  especialista: 'Especialista',
};

/**
 * Selector del "sombrero" activo. Solo aparece si el usuario tiene 2+ perfiles.
 * Cambiar de sombrero es instantáneo (sin re-login): solo cambia el menú/rutas.
 */
export default function PerfilSwitcher() {
  const { perfilActivo, setPerfilActivo, perfiles } = usePerfilActivo();
  if (!perfiles || perfiles.length < 2) return null;

  return (
    <Select
      value={perfilActivo}
      onChange={setPerfilActivo}
      size="small"
      style={{ minWidth: 150 }}
      aria-label="Cambiar de perfil"
      options={perfiles.filter((p) => ETIQUETAS[p]).map((p) => ({ value: p, label: ETIQUETAS[p] }))}
    />
  );
}
